import styled from 'styled-components'
import { theme } from '../../styles'

export const PixWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
`

export const PixQr = styled.img`
  width: 190px;
  height: 190px;
  border-radius: ${theme.raio.md};
  background: ${theme.cores.white};
  padding: 8px;
  border: 1px solid ${theme.cores.border};
`

export const PixCodeRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
`

export const PixCode = styled.code`
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border-radius: ${theme.raio.sm};
  border: 1px solid ${theme.cores.border};
  background: ${theme.cores.accentTint};
  color: ${theme.cores.inkDeep};
  font-size: 12px;
  font-family: monospace;
  text-align: left;
  word-break: break-all;
  max-height: 68px;
  overflow-y: auto;
`

export const PixCopyBtn = styled.button`
  border: 1px solid ${theme.cores.accent};
  border-radius: ${theme.raio.sm};
  background: ${theme.cores.white};
  color: ${theme.cores.accent};
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 0 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease;

  &:hover {
    background: ${theme.cores.accentTint};
  }
`
